// Libs
import { createSelector } from 'reselect'
import _map from 'lodash/map'
import _reduce from 'lodash/reduce'
import _find from 'lodash/find'

// Selectors
import selectedFeatureIndices$ from 'hfty-map/src/selectors/selectedFeatureIndices'
import featuresOfSelectedField$ from 'hfty-map/src/selectors/featuresOfSelectedField'

// Exports
export default createSelector(
  [selectedFeatureIndices$, featuresOfSelectedField$],
  function (selectedFeatures, features) {
    if (!selectedFeatures) {
      return _map(features, (feature) => {
        return {
          ...feature,
          isLocked: false,
        }
      })
    }

    return _reduce(features, (acc, feature, index) => {
      const selectedFeature = _find(selectedFeatures, (selectedIndex) => {
        return feature.properties.featureIndex === selectedIndex
      })

      if (selectedFeature || selectedFeature === 0) {
        acc.push({...feature, isLocked: true})
      } else {
        acc.push({...feature, isLocked: false})
      }

      return acc
    }, [])
  }
)
